import ChartV5 from "../../pages/desempleo-vs-expectativas/ChartV5"

export const MainCP = () => {
  return (
    <div className="container-fluid">
      <div className="row" style={{ marginTop: '40px' }}>
        <div className="col-12">
          <div className="d-flex justify-content-center">
             <ChartV5/>
          </div>
        </div>
      </div>
    </div>
  )
}
